export let dataProps = {
    id: 0, 
    partner_name: '',
    tracking_url: '',
    domestic_rate: 0,
    international_rate: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/shipmentPartner/properties.js